export const DRIVE_MODE_IDS = [
    "wot",
    "01g",
    "02g",
    "dec",
] as const;

export const PHENOMENON_IDS = [
    "mn_aco_24th",
    "mn_aco_48th",
    "mn_aco_72th",
    "mn_aco_96th",
    "mn_vib_24th",
    "mn_vib_48th",
    "mn_vib_72th",
    "mn_vib_96th",
    "gn_pos",
    "gn_fd",
] as const;

export const UNIT_IDS = [
    "fwd",
    "awd_f",
    "awd_r",
] as const;

export const PHENOMENON_GROUP_IDS = [
    "vib",
    "gn",
    "aco",
] as const;
